module.exports = __webpack_public_path__ + "media/images/emblems/Disentis_Muster_wappen-d49842cd92147fd92c49967a57b59a82.svg";